//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "driver-manage",
  data(){
    return{
      wrapperHeight:0,
      allLoaded:false,
      config:{
        title:'司机管理',
        url:'api/driver/page',
        property: "createdDate",
        inputCondition:{
          placeholder:'司机/手机号/车牌号',
          searchCondition:'key',
          rules:[{field:"name-phone-carNumber",option: "LIKE_ANYWHERE"}]
        }
      },
      list:[]
    }
  },
  methods:{
    getList(e,met,bol){
      this.$nextTick(()=>{
        if(bol){
          this.list = this.list.concat(e);
        }else{
          this.list = e;
        }
        if(met === 'top'){
          this.$refs.loadmore.onTopLoaded();
        }
        if(met === 'bottom'){
          this.$refs.loadmore.onBottomLoaded();
        }
      })
    },
    init: function() {
      // 父控件要加上高度，否则会出现上拉不动的情况
      this.wrapperHeight = document.documentElement.clientHeight - this.$refs.wrapper.getBoundingClientRect().top - 10;
    },
    loadTop(){
      this.$refs.header.getlist(true);
    },
    loadBottom(){
      this.$refs.header.getMore();
    }
  },
  mounted(){
    this.init();
    this.$get('api/supplier/current-sample').then((res) => {
      if(res){
        this.config.fixRules = {
          fixed:true,
          rules:[{field:"supplier.id", option: "IN", values:[res.id]}]
        };
        this.$refs.header.addFixRules();
        this.$refs.header.getlist();
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/page/driver/driver-manage.vue